import React from "react";
import PropTypes from "prop-types";
import Badge from "antd/es/badge";
import Card from "antd/es/card";
import Row from "antd/es/row";
import Col from "antd/es/col";
import DetailsColumn from "./DetailsColumn";

const VehicleDetails = ({
  vehicle,
  count,
}) => (
  <Card style={{ marginTop: "20px", borderColor: "#ffb551" }}>
    <Row type="flex" justify="space-between">
      <Col style={{ paddingTop: "5px" }}>
        <Badge
          overflowCount={9999999}
          count={`Vehicle ${count + 1}`}
          className="details-badge"
        />
      </Col>
    </Row>
    <div className="left-margin">
      <Row>
        <DetailsColumn
          label={"Vehicle Make"}
          value={vehicle.vehicle_make || "-"}
        />
        <DetailsColumn
          label={"License Plate"}
          value={vehicle.license_plate || "-"}
        />
        <DetailsColumn
          label={"Parking Space"}
          value={vehicle.parking_space || "-"}
        />
      </Row>
    </div>
    <div style={{ marginRight: "6px", marginBottom: "4px" }}>
      <Row justify={"end"} margin></Row>
    </div>
  </Card>
);

VehicleDetails.propTypes = {
  vehicle: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
};

export default VehicleDetails;
